import { cx } from '@chakra-ui/utils';
import type {
  IndicatorContainerProps as ReactSelectIndicatorContainerProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';

import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type IndicatorsContainerProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectIndicatorContainerProps<OptionType, IsMulti> & {
  innerProps?: BoxProps;
};

export const IndicatorsContainer = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
  children,
}: IndicatorsContainerProps<OptionType, IsMulti>) => {
  const { indicatorsContainer: indicatorsContainerStyles } = useSelectStyles();

  return (
    <Box
      {...innerProps}
      className={cx(
        `${BASE_CLASS_NAME}__indicators-container`,
        innerProps?.className,
      )}
      __css={indicatorsContainerStyles}
    >
      {children}
    </Box>
  );
};
